import React from 'react';
import PropTypes from 'prop-types';

export const ServerVarsContext = React.createContext({});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export function ServerVarsContextProvider({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
    isMobileWebSbVariant,
    isSearchQueryApplied,
}) {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
                isMobileWebSbVariant,
                isSearchQueryApplied,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
}

ServerVarsContextProvider.defaultProps = {
    clientConf: {},
};

ServerVarsContextProvider.propTypes = {
    children: PropTypes.node,
    isDesktop: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isSbAdsEnabled: PropTypes.bool,
    isTablet: PropTypes.bool.isRequired,
    clientConf: PropTypes.object.isRequired,
    localeOrigin: PropTypes.string,
    isMobileWebSbVariant: PropTypes.bool,
    isSearchQueryApplied: PropTypes.bool.isRequired,
};
